<div class="dropdown d-inline-block">
  <a class="dropdown-toggle no-caret" id="user-menu" data-toggle="dropdown" aria-haspopup="true"
    aria-expanded="false" role="button" data-testid="user-menu-settings">
    <i class="fa fa-cog menu-icon" title="Settings" aria-hidden="true"></i>
  </a>

  <div class="dropdown-menu dropdown-menu-right rounded-0 mt-3 p-0 box-shadow" aria-labelledby="user-menu">
    <div class="user-menu">
      <div class="user-info text-center px-3 pt-4 pb-3">
        <img src="assets/img/users/default-user.jpg" alt="user-img" class="user-img rounded-circle">
        <p class="mt-1 mb-0 title" data-testid="user-menu-user-name">
          {{CurrentUserName}}
        </p>
        <small data-testid="user-menu-roles">{{userRoles}}</small>
        <div class="app-version" data-testid="user-menu-version">version: {{appVersion}}</div>
      </div>

      <hr class="mb-1" />

      <a class="dropdown-item my-1" (click)="logout()" role="button" data-testid="user-menu-log-out">
        <i class="fa fa-sign-out mr-2" title="Sign Out" aria-hidden="true"></i>
        Log out
      </a>

    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/core/components/user-menu/user-menu.component.html